export var CALCULATION_TYPE;
(function (CALCULATION_TYPE) {
    CALCULATION_TYPE["MATERIAL"] = "\uC7AC\uB8CC";
    CALCULATION_TYPE["SERVICE"] = "\uC11C\uBE44\uC2A4 / \uC9C1\uC811 \uC785\uB825";
})(CALCULATION_TYPE || (CALCULATION_TYPE = {}));
